import type { ClientUser, TradeMode } from './types'

const ACCESS_TOKEN_KEY = 'velox.access_token'
const TRADE_MODE_KEY = 'velox.trade_mode'
const CLIENT_KEY = 'velox.client'
/** Legacy key — cleared on read for migrations from older builds. */
const LEGACY_REFRESH_KEY = 'velox.refresh_token'

/**
 * Sanctum token + session metadata in localStorage.
 * Swap for HttpOnly cookie storage in production without changing interceptors.
 */
export const tokenStore = {
  getAccessToken(): string | null {
    try {
      return localStorage.getItem(ACCESS_TOKEN_KEY)
    } catch {
      return null
    }
  },

  getTradeMode(): TradeMode | null {
    try {
      const v = localStorage.getItem(TRADE_MODE_KEY)
      return v === 'full' || v === 'read' ? v : null
    } catch {
      return null
    }
  },

  getClient(): ClientUser | null {
    try {
      const raw = localStorage.getItem(CLIENT_KEY)
      if (!raw) return null
      return JSON.parse(raw) as ClientUser
    } catch {
      return null
    }
  },

  setSession(
    access: string,
    meta?: { tradeMode?: TradeMode; client?: ClientUser },
  ): void {
    localStorage.setItem(ACCESS_TOKEN_KEY, access)
    try {
      localStorage.removeItem(LEGACY_REFRESH_KEY)
    } catch {
      /* ignore */
    }
    if (meta?.tradeMode) {
      localStorage.setItem(TRADE_MODE_KEY, meta.tradeMode)
    }
    if (meta?.client) {
      localStorage.setItem(CLIENT_KEY, JSON.stringify(meta.client))
    }
  },

  /** @deprecated Use setSession — kept for brief compatibility. */
  setTokens(access: string): void {
    this.setSession(access)
  },

  clear(): void {
    localStorage.removeItem(ACCESS_TOKEN_KEY)
    localStorage.removeItem(TRADE_MODE_KEY)
    localStorage.removeItem(CLIENT_KEY)
    localStorage.removeItem(LEGACY_REFRESH_KEY)
  },
}
